import { Rule } from '@webkit/validation/value';

export const checked = (expected: boolean = true, customError?: string, hideError: boolean = false): Rule<boolean> => ({
    id: 'checked',
    validator: value => !!value === expected,
    error: () => {
        if (customError) return customError;
        if (hideError) return '';
        return expected ? 'Must be checked' : 'Must be unchecked';
    },
});
